import type { InitOptions } from 'i18next'

import en from '@/locales/en.json'
import fr from '@/locales/fr.json'

export type I18nLocales = Pick<InitOptions, 'lng' | 'fallbackLng'>

/**
 * the i18next options the app boots with, shared with i18n.test.tsx so the test
 * exercises the real configuration rather than a copy of it
 */
export function i18nInitOptions({ lng, fallbackLng }: I18nLocales): InitOptions {
  return {
    resources: {
      en: { translation: { ...en } },
      fr: { translation: { ...fr } },
    },
    lng, // if you're using a language detector, do not define the lng option
    fallbackLng,
    interpolation: {
      escapeValue: false,
    },
  }
}
